export default "__VITE_ASSET__ZxThwoiZ__"